import { useEffect, useRef } from 'react';
import { DialogLayer } from '../ui/Dialog';
import { downloadInvoicePdf } from './pdfLink';

/** The frame's address: `v` is the card's version, so the frame loads the PDF again after every change. */
export const previewSrc = (invoiceId: string, version: number) => `/api/invoices/${invoiceId}/pdf?inline=1&v=${version}`;

/**
 * "Podgląd PDF" of a draft invoice (owner 2026-10-20 23:51): the F35 draft PDF ("PROJEKT", never stored) in a frame —
 * next to the card on a wide screen (`side`), over the whole screen on a phone (`full`), as the quote's preview (P8).
 * The card's version in the address reloads it after each change. Nothing is saved or sent.
 */
export function InvoicePdfPreview({ invoiceId, version, full, onClose }: { invoiceId: string; version: number; full: boolean; onClose: () => void }) {
  const close = useRef<HTMLButtonElement>(null);
  const src = previewSrc(invoiceId, version);
  useEffect(() => {
    if (full) close.current?.focus();
  }, [full]);
  const body = (
    <>
      <div className="inv-pdf-head">
        <h2 id="inv-pdf-preview-title">Podgląd PDF</h2>
        <div className="actions">
          <a className="btn small ghost" href={src} target="_blank" rel="noopener">
            Otwórz w nowej karcie
          </a>
          <button className="btn small" type="button" onClick={() => downloadInvoicePdf(invoiceId)}>
            Pobierz PDF
          </button>
          {/* Escape only over the whole screen; beside the card it is the invoice fields' (review I3) */}
          {full && <DialogLayer onClose={onClose} />}
          <button ref={close} className={full ? 'btn small primary' : 'btn small'} type="button" onClick={onClose}>
            Zamknij
          </button>
        </div>
      </div>
      <iframe key={src} className="inv-pdf-frame" src={src} title="PDF faktury roboczej (projekt)" />
    </>
  );
  if (!full) {
    return (
      <aside className="inv-pdf-side" aria-labelledby="inv-pdf-preview-title" data-feature-id="invoices.pdf_preview">
        {body}
      </aside>
    );
  }
  return (
    <div className="dialog-backdrop">
      <div className="dialog panel inv-pdf-dialog" role="dialog" aria-modal="true" aria-labelledby="inv-pdf-preview-title" data-feature-id="invoices.pdf_preview">
        {body}
      </div>
    </div>
  );
}
